// src/pages/IncidentReportForm_02.tsx
import React from 'react';
import MainLayout from '../../layouts/MainLayout.tsx';
import { useNavigate, useLocation } from 'react-router';
import { baseurly } from '../../utils/apis.ts';
import { X_API_KEY } from '../../utils/apis.ts';
import { Incident } from '../../Interfaces/types.ts';
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

interface LocationState {
  equipmentName?: string;
}
interface Props {
    data: Incident;
    onChange: (f: Partial<Incident>) => void;
    onBack: () => void;
    onDone: () => void;
  }
 const IncidentReportForm_02: React.FC<Props> = ({ data, onChange, onBack, onDone,}) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const equipmentName =
    (state as LocationState)?.equipmentName || 'Equipment';

  return (
    <MainLayout>
      <div className="min-h-screen bg-blue-900 pb-20">
        {/* Page Title */}
        <div className="px-4 sm:px-6 pt-6">
          <h1 className="text-white text-lg font-medium">
            Equipment Incident Form
          </h1>
        </div>

        {/* White card */}
        <div className="mt-4 bg-white rounded-t-3xl pb-10">
          {/* Sub-header with title + image */}
          <div className="bg-white border rounded-3xl p-4 sm:p-8 mx-4 sm:mx-6 flex flex-col sm:flex-row justify-between items-center">
            <h2 className="font-bold text-blue-900 text-lg mb-4 sm:mb-0">
              {equipmentName} Incident Report Form: Page 2
            </h2>
            <img
              src={digitalOceanImageUrl("products/kayoola_coach/images/orders-coach/carousel.png")}
              alt="Equipment"
              className="w-32 h-auto"
            />
          </div>

          <form 
                className="mt-6 mx-4 sm:mx-6 space-y-8"
                onSubmit={e => {
                  e.preventDefault();
                  onDone();}}
          
          >
            {/* Five Whys */}
            <div className="bg-blue-50 p-6 rounded-lg space-y-6">
              <h3 className="text-blue-900 font-semibold text-lg">
                The Five Whys
              </h3>

              <div>
                <label className="block text-gray-700 mb-1">
                  Define the Problem:
                </label>
                <textarea
                  rows={3}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={data.problem}
                  onChange={(e) => onChange({ problem: e.target.value })}

                />
              </div>

              <div>
                <label className="block text-gray-700 mb-1">
                  Primary Cause: Why is it happening?
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={data.why1}
                  onChange={(e) => onChange({ why1: e.target.value })}
                />
              </div>

              {[1, 2, 3].map((i) => (
                <div key={i}>
                  <label className="block text-gray-700 mb-1">
                    Why is that?
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded px-3 py-2"
                    value={data[`why${i + 1}`]}
                    onChange={(e) => onChange({ [`why${i + 1}`]: e.target.value })}
                  />
                </div>
              ))}

              <div>
                <label className="block text-gray-700 mb-1">
                  Root Cause: Why is that?
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
            </div>

            {/* Corrective Action */}
            <div className="bg-blue-50 p-6 rounded-lg space-y-6">
              <h3 className="text-blue-900 font-semibold text-lg">
                Corrective Action
              </h3>

              <div>
                <label className="block text-gray-700 mb-1">Action</label>
                <textarea
                  rows={3}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={data.action}
                  onChange={(e) => onChange({ action: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-gray-700 mb-1">
                  Party Responsible
                </label>
                <input 
                      className="w-full border border-gray-300 rounded px-3 py-2"
                      value={data.party_responsible}
                      onChange={(e) => onChange({ party_responsible: e.target.value })}/>
                      
                
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-gray-700 mb-1">
                    Action Start Date
                  </label>
                  <input 
                        type="date" 
                        className="border border-gray-300 rounded px-3 py-2" 
                        value={data.start_date}
                        onChange={(e) => onChange({ start_date: e.target.value })}/>
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">
                    Action End Date
                  </label>
                  <input 
                      type="date" 
                      className="border border-gray-300 rounded px-3 py-2"
                      value={data.end_date} 
                      onChange={(e) => onChange({ end_date: e.target.value })}/>
                </div>
              </div>
            </div>

            {/* Done button */}
            <div className="text-center">
              <button
                type="submit"
                onClick={() => navigate("/incidentlanding")}
                className="inline-block bg-blue-900 text-white px-8 py-2 rounded-full hover:bg-blue-800"
              >
                Done
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
};

export default IncidentReportForm_02;
